<template>
<div>
	<ul class="title-nav">
		<li>
			<div v-on:click="routeBack()" class="back-btn">
				<i class="material-icons md-18">keyboard_arrow_left</i>
			</div> 
			
			<div class="title-label"><i class="material-icons md-18">vpn_key</i> PASSWORD</div>
		</li>
	</ul>

	<div class="category">
		<div class="category-title">ACTIVE PASSWORD</div>
		<div class="property-row">
			<div class="text-break property-locked">
				Your password is encypted and stored on our secure servers. If you'd like to change your password, click the button below and an email will be sent to you which will include a reset link.
			</div>
		</div>
		<div v-if="mode == 'view'" class="property-row">
			<button v-on:click="resetPassword" class="btn btn-light btn-sm float-right">Reset Password</button>
		</div>
		<div v-if="mode == 'sent'" class="property-row">
			<button v-on:click="resetPassword" class="btn btn-light btn-sm float-right" disabled>Reset Password</button>
		</div>
	</div>

	<contentLoading :loading="loading"/>
	<contentAlert :alert="alert"/>
</div>

</template>

<script>

import contentAlert from '../content/content-alert';
import contentLoading from '../content/content-loading';

export default {
	components:{
		contentAlert,
		contentLoading
	},
	data: function(){
		return {
			error:null,
			mode:'view',
			alert:null,
			loading:false,
		}
	},
	props: {
		agent:{
			type:Object
		},
	},
	methods:{
		routeBack:function(){
			this.$router.push({
				name:'agent',
			});
		},
		resetPassword:function(){
			this.mode = 'sent';
			this.loading = true;
			this.$store.dispatch('AGENT_RESET_PASSWORD', {email:this.agent.email}).then((res)=>{
				this.loading = false;
				this.alert = 'reset password email sent';
			}).catch((err)=>{
				this.loading = false;
			});
		},
	},
}

</script>


// WEBPACK FOOTER //
// src/components/agent/agent-password.vue